import React from "react";
import Hero from "../components/Hero";
import SectionBelow from "../components/SectionBelow";
import SectionBelow2 from "../components/SectionBelow2";
import { SectionInterface } from "../interfaces/Section";
import SectionBelow3 from "../components/SectionBelow3";
import Whyme from "../components/Whyme";
import Projects from "../components/Projects";
import Contact from "../components/Contact";


const Home = () => {
  const sesction2: SectionInterface = {
    title: "",
    content: "content",
  };

  const sesction1: SectionInterface = {
    title: "",
    content: "content",
  };

  const sesction3: SectionInterface = {
    title: "",
    content: "content",
  };

  return (
    <div>
      <Hero />
      <SectionBelow sectionInterface={sesction1} />
      <SectionBelow2 sectionInterface={sesction2} />
      <SectionBelow3 sectionInterface={sesction3} />
      <Whyme />
      <Projects />
      <Contact />
    </div>
  );
};

export default Home;
